import { MailView } from "./components/MailView";
import { MaintenanceSection, MaintenanceSectionContent, MaintenanceSectionHeader } from "@/components/layout/maintenance";

/**
 * The Emails page: the signed-in user's own mail across every customer, synchronised from
 * their mailbox or sent and received with Klipboard CRM contacts.
 */
export const MailInboxPage = () => (
  <MaintenanceSection>
    <MaintenanceSectionHeader
      title="Emails"
      subtitle="Your emails with contacts and customers, across every account."
      noMargin
    />
    <MaintenanceSectionContent>
      <div className="py-3">
        <MailView source={{ kind: "mine" }} />
      </div>
    </MaintenanceSectionContent>
  </MaintenanceSection>
);
